import { Auth } from 'aws-amplify';


/**
 * Get permissions from current user's JWT token
 * Permissions are stored in Cognito custom:permissions claim as JSON string
 */
export const getPermissionsFromJWT = async () => {
  try {
    const session = await Auth.currentSession();
    const idToken = session.getIdToken();
    const payload = idToken.decodePayload();

    // Cognito stores custom attributes as custom:attributeName
    const permissionsStr = payload['custom:permissions'];
    if (!permissionsStr) {
      console.warn('No permissions found in JWT custom:permissions claim');
      return [];
    }

    // Permissions stored as JSON string, parse it
    const permissions = JSON.parse(permissionsStr);
    if (!Array.isArray(permissions)) {
      console.warn('Permissions in JWT is not an array:', permissions);
      return [];
    }

    return permissions;
  } catch (error) {
    console.error('Error getting permissions from JWT:', error);
    return [];
  }
};

/**
 * Get role from current user's JWT token
 * Role is stored in Cognito custom:role claim
 */
export const getRoleFromJWT = async () => {
  try {
    const session = await Auth.currentSession();
    const idToken = session.getIdToken();
    const payload = idToken.decodePayload();

    const role = payload['custom:role'];
    if (!role) {
      console.warn('No role found in JWT custom:role claim');
      return null;
    }

    return role;
  } catch (error) {
    console.error('Error getting role from JWT:', error);
    return null;
  }
};



export default {
  getPermissionsFromJWT,
  getRoleFromJWT,
};
